import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SavedSearches = ({ savedSearches, onLoadSearch, onDeleteSearch, onCreateAlert }) => {
  if (savedSearches?.length === 0) {
    return (
      <div className="bg-card border border-border rounded-lg p-6 mb-6">
        <div className="text-center py-8">
          <Icon name="Search" size={48} className="text-muted-foreground mx-auto mb-4" />
          <h3 className="text-lg font-semibold text-foreground mb-2">No Saved Searches</h3>
          <p className="text-sm text-muted-foreground">
            Save your frequently used search queries and filters for quick access.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Icon name="BookmarkCheck" size={20} className="text-foreground" />
          <h2 className="text-lg font-semibold text-foreground">Saved Searches</h2>
        </div>
        <span className="text-sm text-muted-foreground">
          {savedSearches?.length} saved
        </span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {savedSearches?.map((search) => (
          <div
            key={search?.id}
            className="border border-border rounded-lg p-4 hover:shadow-subtle transition-shadow duration-200"
          >
            <div className="flex items-start justify-between mb-3">
              <div className="flex-1">
                <h3 className="font-semibold text-foreground mb-1">{search?.name}</h3>
                <p className="text-sm text-muted-foreground line-clamp-2">
                  {search?.description}
                </p>
              </div>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onDeleteSearch(search?.id)}
                className="p-1 ml-2"
              >
                <Icon name="Trash2" size={16} className="text-muted-foreground hover:text-error" />
              </Button>
            </div>

            <div className="flex items-center gap-2 mb-3">
              <div className="flex items-center gap-1 text-xs text-muted-foreground">
                <Icon name="Calendar" size={12} />
                <span>Created {new Date(search.createdAt)?.toLocaleDateString()}</span>
              </div>
              <div className="flex items-center gap-1 text-xs text-muted-foreground">
                <Icon name="Eye" size={12} />
                <span>{search?.usageCount} uses</span>
              </div>
            </div>

            <div className="flex items-center gap-2 mb-4">
              {search?.filters?.market !== 'all' && (
                <span className="px-2 py-1 bg-primary/10 text-primary text-xs rounded-full">
                  {search?.filters?.market?.toUpperCase()}
                </span>
              )}
              {search?.filters?.impact !== 'all' && (
                <span className="px-2 py-1 bg-accent/10 text-accent text-xs rounded-full">
                  {search?.filters?.impact} impact
                </span>
              )}
              {search?.query && (
                <span className="px-2 py-1 bg-success/10 text-success text-xs rounded-full">
                  "{search?.query}"
                </span>
              )}
            </div>

            <div className="flex items-center gap-2">
              <Button
                variant="outline"
                size="sm"
                onClick={() => onLoadSearch(search)}
                className="flex-1 flex items-center justify-center gap-2"
              >
                <Icon name="Search" size={14} />
                <span>Load</span>
              </Button>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onCreateAlert(search)}
                className="flex items-center gap-2"
              >
                <Icon name="Bell" size={14} />
                <span>Alert</span>
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SavedSearches;